export default __webpack_public_path__ + "static/media/us-wy.8ca61be1.svg";